<!-- Mobile Year Filter Dialog -->
@if (isOpen()) {
  <div
    class="dialog-backdrop fixed inset-0 z-50 bg-black/50 md:hidden"
    (clickOutside)="closeDialog()"
    (keydown.enter)="closeDialog()"
    dhpClickOutside
    tabindex="0"
  >
    <div class="absolute right-0 bottom-0 left-0 rounded-t-3xl bg-white p-6">
      <div class="mb-6 flex items-center justify-between">
        <h2 class="text-xl font-medium">
          {{ 'components.yearFilterDialog.title' | translate }}
        </h2>
        <button
          class="btn"
          (click)="closeDialog()"
          (keydown.enter)="closeDialog()"
          tabindex="0"
        >
          <img
            class="h-4 w-4"
            [alt]="'components.header.close' | translate"
            src="assets/icons/close.svg"
          />
        </button>
      </div>
      <div class="flex flex-col space-y-4">
        @for (year of years(); track year) {
          @if (year.count !== 0) {
            <button
              class="rounded-full px-4 py-2 transition-all duration-300 hover:bg-black hover:text-white"
              [ngClass]="
                yearSelected()?.value === year.value
                  ? 'bg-black text-white'
                  : 'border border-black bg-white text-black'
              "
              (click)="selectYear(year)"
            >
              <span>{{ year.label }}</span>
              <span>({{ year.count }})</span>
            </button>
          }
        }
      </div>
    </div>
  </div>
}
